//? Note: jurisdiction specific component

import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import { getCMSObject, WinnerLink } from 'sg-ui-components';

const telescriptWinnerLink = getCMSObject('data.components.teleScripts.WinnerLink.jsonBlock');

const WinnerLinkWrapper = ({ selected, config }) => {
    const isWinnerLinkEnabled = config?.web?.features?.isWinnerLinkEnabled;

    if (!isWinnerLinkEnabled) {
        return () => null;
    }
    return <WinnerLink selected={selected} telescript={telescriptWinnerLink} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(WinnerLinkWrapper);
